import React from "react";
import { User } from "lucide-react";
import { PageHero, PageBody, FONT } from "./_shared";
import { useBul } from "./BulLayout";

export default function Leadership() {
  const data = useBul();
  const list = data.leadership || [];
  return (
    <div data-testid="bul-leadership">
      <PageHero eyebrow="Leadership" title="Messages from the Leadership" />
      <PageBody>
        {list.length === 0 ? (
          <div className="text-center bg-white p-16 border border-[#D9D2C1] text-[#726C61]">
            Messages will appear here once the institute publishes them.
          </div>
        ) : (
          <div className="space-y-12">
            {list.map((m, i) => (
              <article
                key={m.id}
                data-testid={`bul-leader-${m.designation.replace(/\s+/g, "-")}`}
                className={`bg-white border-l-4 border-[#FDBB30] flex flex-col md:flex-row ${i % 2 === 1 ? "md:flex-row-reverse md:border-l-0 md:border-r-4" : ""}`}
              >
                <div className="md:w-1/3 bg-[#0F0F10] flex items-center justify-center p-10">
                  <div className="w-44 h-44 overflow-hidden ring-4 ring-[#FDBB30] bg-[#EDE7DA]">
                    {m.photo_url ? (
                      <img src={m.photo_url} alt={m.name} className="w-full h-full object-cover" loading="lazy" />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center text-[#726C61]">
                        <User size={48} strokeWidth={1.5} />
                      </div>
                    )}
                  </div>
                </div>
                <div className="flex-1 p-10">
                  <div className="text-[10px] tracking-[0.4em] uppercase text-[#FDBB30] font-semibold">
                    {m.designation}
                  </div>
                  <h2 className="mt-2 text-3xl md:text-4xl text-[#0F0F10] leading-tight" style={{ fontFamily: FONT.serif, fontWeight: 700 }}>
                    {m.name || "—"}
                  </h2>
                  <div
                    className="prose prose-slate max-w-none mt-6 text-[#2A2A2B] leading-[1.9]"
                    dangerouslySetInnerHTML={{ __html: m.message_html }}
                  />
                </div>
              </article>
            ))}
          </div>
        )}
      </PageBody>
    </div>
  );
}
